import { TTwoUtpBlock } from 'shared/types/utp';

export const UTP: TTwoUtpBlock = [
  { title: 'Застройщики', image: 'crane' },
  { title: 'Официальные представители девелоперов', image: 'building' },
];
